import type { FormatterArgs } from '@/services/types/formatter';

export default ({ ctx, data, key }: FormatterArgs) => ({
  kind: 'suspicious-event',
  value: data[key],
  noDataLabel: ctx.t('No data'),
});
